import {BuyFeatureModule} from '@gongxigames/framework/slot/modules/buyFeature/BuyFeatureModule';
import {BuyFeatureView} from '@gongxigames/framework/slot/modules/buyFeature/BuyFeatureView';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels/ReelsEvents';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad/UIDisableReason';
import {BuyFeatureStates} from '@gongxigames/framework/slot/modules/buyFeature/BuyFeatureStates';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {BuyFeatureBasicState} from '@gongxigames/framework/slot/modules/buyFeature/states/BuyFeatureBasicState';
import {FlowModuleEvents} from '@gongxigames/framework/slot';

export class BuyFeatureWaitingState extends ModuleState<BuyFeatureView, BuyFeatureModule> {
    private isFeatureTriggered = false;

    public onEnterState(): void {
        this.isFeatureTriggered = !this.module.logic.nextActionIsSpin();
        this.module.disableShowPopupButtonByName(BuyFeatureBasicState.REASON_NAME);
    }

    public onLeaveState(): void {
        this.isFeatureTriggered = false;
        this.module.enableShowPopupButtonByName(UIDisableReason.TRIGGERING_FEATURE);
    }

    protected setupEvents(): void {
        this.setEventHandler(ReelsEvents.SPIN_ENDED, this.onSpinEnded.bind(this));
        this.setEventHandler(FlowModuleEvents.ENTER_BASIC_STATE, this.checkIfSpinNext.bind(this));
    }

    protected onSpinEnded(): void {
        if (!this.isFeatureTriggered) {
            this.isFeatureTriggered = !this.module.logic.nextActionIsSpin();
            this.checkIfSpinNext();
        }
    }

    protected checkIfSpinNext(): void {
        if (this.module.logic.nextActionIsSpin()) {
            this.module.gotoState(BuyFeatureStates.BASIC);
        }
    }
}
